import classnames from 'classnames';

import style from './collapsible-list-section-content.module.less';

import type { CollapsibleListSectionContentComponent } from './collapsible-list-section-content-types';

export const CollapsibleListSectionContent: CollapsibleListSectionContentComponent = ({ children, className = null }) => {
  return <div className={classnames(style['collapsible-list-section-content'], className)}>{children}</div>;
};
